module.exports = __webpack_public_path__ + "static/gurus_main-1aa8c9128cd6aa9c793f8c05965fff7d.gif";